  <app-left-nav
  [showLeftNav]="showLeftNav"
  (onListingsClick)="closeLeftNav()"
  (onCloseLeftNavClick)="closeLeftNav()"></app-left-nav>
  <app-right-nav
    [showRightNav]="showRightNav"
    (toFavourites)="toFavourites($event)"
    (toSavedSearches)="toSavedSearches($event)"
    (openSignIn)="openSignIn($event)"
    (toMyAccount)="toMyAccount($event)"
    (logout)="logout()"
    (onCloseRightNavClick)="closeRightNav()"
    (toFavouriteAgent)="toFavouriteAgent($event)"
  ></app-right-nav>
